// extracted by mini-css-extract-plugin
export default {"menuContainer":"menu_menuContainer__m+laI","center":"menu_center__hmZ3V"};